'use client';

import * as React from 'react';
import { WidgetId } from '@/edge/constants';
import { SignOut } from '@/shared/components/icons';
import { useAuthSignOutMutation } from '@/shared/modules/authorization';
import { useEdgeConfigWidget } from '@/shared/modules/edge-config';
import { buildQaTrackingEntityProps } from '@/shared/modules/qa-tracking-entity';
import { ConfirmationSignOutModal } from '../confirmation-sing-out-modal';
import * as Styled from './sign-out-button.styled';
export const SignOutButton = React.memo(function SignOutButton() {
  const profileModel = useEdgeConfigWidget(WidgetId.Profile);
  const [confirmationSignOutModalIsOpen, setConfirmationSignOutModalIsOpen] = React.useState(false);
  const {
    mutate: signOut,
    isPending
  } = useAuthSignOutMutation({
    redirectPathnameOnSuccess: profileModel.links.redirectUrlAfterLogOut
  });
  const handleSignOut = React.useCallback(() => {
    signOut({
      type: 'soft'
    });
    closeConfirmationSignOutModal();
  }, [signOut]);
  const openConfirmationSignOutModal = () => setConfirmationSignOutModalIsOpen(true);
  const closeConfirmationSignOutModal = () => setConfirmationSignOutModalIsOpen(false);
  return <>
      <Styled.ActionButton size="l" icon={SignOut} onClick={openConfirmationSignOutModal} disabled={isPending} {...buildQaTrackingEntityProps('newProfile.header.signOut')} />
      <ConfirmationSignOutModal isOpen={confirmationSignOutModalIsOpen} onConfirm={handleSignOut} onCancel={closeConfirmationSignOutModal} />
    </>;
});